export {
  PaymentDocumentsRegistry,
  PaymentDocumentsRegistryHeader,
  AddPaymentDocument,
} from './components';
